<div class="wrap-login100">
    <form class="login100-form validate-form">
        <div class="text-center logo">
            <img src="assets/images/logo1.png" alt="logo" width="120px">
        </div>
        <ng-container *ngIf="stepPhone == 1">
            <div class="wrap-input100 validate-input" *ngIf="step==2">
                <input class="input100" type="text" [(ngModel)]="user.lastname" name="lastname" placeholder="Nom">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
            <div class="wrap-input100 validate-input" *ngIf="step==2">
                <input class="input100" type="text" [(ngModel)]="user.phone" name="phone" placeholder="Téléphone">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
            <div class="wrap-input100 validate-input">
                <input class="input100" type="text" [(ngModel)]="user.email" name="email" placeholder="Email">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
            <div class="wrap-input100 validate-input" *ngIf="step==1 || step==2">
                <input class="input100" type="password" [(ngModel)]="user.password" spellcheck=false name="pass"
                    placeholder="Mot de Passe">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
            <div class="wrap-input100 validate-input" *ngIf="step==2">
                <input class="input100" type="password" [(ngModel)]="user.confirmePassword" spellcheck=false
                    name="confirmePassword" placeholder="Confirmer votre mot de passe">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
        </ng-container>
        <ng-container *ngIf="stepPhone == 2">
            <div class="wrap-input100 validate-input">
                <input class="input100" type="text" [(ngModel)]="phone" name="phone2" placeholder="Téléphone">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
        </ng-container>


        <div class="container-login100-form-btn">
            <ng-container *ngIf="stepPhone == 1">
                <button *ngIf="step==1" class="login100-form-btn" (click)="login()" [disabled]="loader">
                    <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                    </ng-container>
                    Connexion
                </button>
                <button *ngIf="step==2" class="login100-form-btn" (click)="signup()" [disabled]="loader">
                    <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                    </ng-container>
                    S'inscrire
                </button>
                <button *ngIf="step==3" class="login100-form-btn" (click)="sendPassword()" [disabled]="loader">
                    <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                    </ng-container>
                    Envoyer
                </button>
            </ng-container>
            <ng-container *ngIf="stepPhone == 2">
                <button class="login100-form-btn" (click)="valide()" [disabled]="loader">
                    <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                    </ng-container>
                    Valider
                </button>
            </ng-container>
        </div>

        <ng-container *ngIf="stepPhone == 1 && step==1">
            <div class="google-btn" (click)="signIn('google')">
                <div class="google-icon-wrapper">
                    <img class="google-icon"
                        src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" />
                </div>
                <p class="btn-text"><b>Connectez-vous avec Google</b></p>
            </div>

            <div class="fc-btn" (click)="signIn('facebook')">
                <div class="fc-icon-wrapper">
                    <img class="fc-icon" src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png" />
                </div>
                <p class="btn-text"><b>Connectez-vous avec Facebook</b></p>
            </div>
        </ng-container>
        


        <div class="footer" *ngIf="stepPhone == 1">
            <div class="text-center a1">
                <a class="txt2 cursor-pointer" (click)="step=3" *ngIf="step==1">
                    Mot de passe oublié?
                </a>
            </div>

            <div class="text-center a2">
                <button (click)="step=1" *ngIf="step==3 || step==2" class="login-btn">
                    Se connecter &nbsp;&nbsp;
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </button>
                <button (click)="step=2" *ngIf="step==1" class="login-btn">
                    S'inscrir &nbsp;&nbsp;
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </button>
            </div>
        </div>
        
        <div class="footer" *ngIf="stepPhone == 2">
            <div class="a1">
                <a class="txt2 cursor-pointer" (click)="stepPhone=1">
                    Retour
                </a>
            </div>
        </div>

        <ng-container *ngIf="step==2">
            <div class="form-group" *ngIf="step==2">
                <p>Aprés l'inscription, merci de consulter votre boite email pour valider votre inscription.</p>
            </div>
        </ng-container>
        <ng-container *ngIf="step==3">
            <p>
                Merci de consulter votre boite email pour obtenir votre mot de passe après la validation.
            </p>
        </ng-container>
    </form>
</div>